import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1, a as CHECK_CIRCLE_FILLED_16 } from './mapy-icon3.js';
import { l as transDialog, g as getLocale } from './utils2.js';
import { d as defineCustomElement$3 } from './mapy-icon2.js';
import { d as defineCustomElement$2 } from './mapy-review-tooltip2.js';

const mapyReviewUserCss = ":host{display:block}.user{margin:0;font-size:14px;font-style:normal;font-weight:400;line-height:20px;text-align:center}.verifiedUser{display:inline-block;margin-left:4px;position:relative;top:2px;cursor:pointer}mapy-review-tooltip{z-index:12}.tooltipTitle{margin:0;padding:0;font-size:14px;line-height:18px;color:#fff;font-weight:700}.tooltipDesc{margin:0;margin-top:8px;padding:0;font-size:14px;line-height:18px;color:#fff;font-weight:400}.tooltipDesc a{color:#0ED04A;text-decoration:none}.tooltipDesc a:hover{color:#1EAE00}";
const MapyReviewUserStyle0 = mapyReviewUserCss;

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyReviewUser_lang;
defineCustomElement$1();
const MapyReviewUser = /*@__PURE__*/ proxyCustomElement(class MapyReviewUser extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        _MapyReviewUser_lang.set(this, "");
        this.bindToolTipDesc = (linksRef) => {
            linksRef.innerHTML = transDialog(__classPrivateFieldGet(this, _MapyReviewUser_lang, "f"), "verifiedUserText");
            const links = Array.from(linksRef.querySelectorAll("a"));
            if (links.length === 1) {
                links[0].addEventListener("pointerdown", () => {
                    this.signal.emit({
                        name: "verified-info-click",
                    });
                });
            }
        };
        this.user = "";
        this.verifiedUser = false;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewUser_lang, getLocale(this.hostElement), "f");
    }
    render() {
        return (h(Host, { key: 'bec74db3722c76d1498ecc80a8aee58dd433d39c' }, h("p", { key: 'a4a083a4a2704c4ee28fda0752634496b823bd0b', class: "user", innerHTML: transDialog(__classPrivateFieldGet(this, _MapyReviewUser_lang, "f"), "reviewAsUser", { user: `<strong>${this.user}</strong>` }) }, this.verifiedUser && h("span", { class: "verifiedUser" }, h("mapy-icon", { size: CHECK_CIRCLE_FILLED_16.size, style: { color: "rgb(29, 161, 242)" }, d: CHECK_CIRCLE_FILLED_16.d }, h("path", { d: CHECK_CIRCLE_FILLED_16.d })), h("mapy-review-tooltip", { width: 232 }, h("h3", { class: "tooltipTitle" }, transDialog(__classPrivateFieldGet(this, _MapyReviewUser_lang, "f"), "verifiedUserTitle")), h("p", { class: "tooltipDesc", ref: this.bindToolTipDesc }))))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewUserStyle0; }
}, [1, "mapy-review-user", {
        "user": [513],
        "verifiedUser": [516, "verified-user"]
    }]);
_MapyReviewUser_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-user", "mapy-icon", "mapy-review-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-user":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewUser);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewUser as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-user2.js.map